// Sumy došlého dokladu a jeho položiek — rovnaké pravidlo ako backend/modules/doklad_polozky.js (pri zmene upraviť oba súbory).
// Mirko 17. 9. 2026: office hlási, že delenie faktúry zle rozdelí kusy aj sumu. Bloček z eKasy má položky s DPH,
// faktúru office zapisuje tak, ako je vytlačená — položky bez DPH. Pri faktúre rozhodnú sumy, inak platí predvolené.
const cislo = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const tolerancia = (suma) => Math.max(0.05, Math.abs(suma) * 0.005)
export const sumaPolozky = (p) => cislo(p && (p.price_total != null ? p.price_total : (p.amount_total != null ? p.amount_total : (p.amount != null ? p.amount : (p.suma != null ? p.suma : p.total)))))
const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100
const sumaPoloziek = (polozky) => r2((polozky || []).reduce((s, p) => s + r2(sumaPolozky(p)), 0))   // riadky tak, ako sú na doklade (Mirko: „sumy sú dané na faktúre“)
const jeBlocek = (d) => String(d.doc_type || d.docType || '') === 'blocok' || d.typ === 'BLOCEK'

function zakladZHlavicky(d) {
  const ex = cislo(d.amount_ex_vat != null ? d.amount_ex_vat : d.amount_excl_vat)
  if (ex > 0) return ex
  try {
    const v = typeof d.vat_lines === 'string' ? JSON.parse(d.vat_lines || '[]') : (d.vat_lines || [])
    const b = (Array.isArray(v) ? v : []).reduce((s, x) => s + cislo(x.base), 0)
    if (b > 0) return b
  } catch (_) {}
  return 0
}
function zakladOdhadom(d) {
  const tot = cislo(d.amount_total), vat = cislo(d.vat_amount != null ? d.vat_amount : d.amount_vat), rate = cislo(d.vat_rate)
  if (vat > 0 && tot > vat) return tot - vat
  return rate > 0 ? tot / (1 + rate / 100) : tot
}
// predvoleneSDph: čo platí, keď sumy nerozhodnú (došlá faktúra = bez DPH; doklady mimo Došlých FA ostávajú ako doteraz s DPH)
export function polozkySDph(d, polozky, predvoleneSDph = false) {
  if (!d) return predvoleneSDph
  if (jeBlocek(d)) return true
  const s = sumaPoloziek(polozky), tot = cislo(d.amount_total)
  if (!(s > 0) || !(tot > 0)) return predvoleneSDph
  const tol = tolerancia(tot)
  if (Math.abs(s - (zakladZHlavicky(d) || zakladOdhadom(d))) <= tol) return false
  if (Math.abs(s - tot) <= tol) return true
  return predvoleneSDph
}
export function zakladDokladu(d, polozky) {
  const h = zakladZHlavicky(d)
  if (h > 0) return Math.round(h * 100) / 100
  if ((polozky || []).length && !polozkySDph(d, polozky)) {
    const s = sumaPoloziek(polozky)
    if (s > 0 && Math.abs(s - zakladOdhadom(d)) <= tolerancia(cislo(d.amount_total))) return Math.round(s * 100) / 100
  }
  return Math.round(zakladOdhadom(d) * 100) / 100
}
